<template>
  <div>
    <section-definition title="page.title"></section-definition>
    <v-container fluid>


      test


    </v-container>
  </div>
</template>
<script>
   export default {
      data() {
         return {

         };
      }
   };
</script>
